// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_h0-6";
export var emphasizeQuantity = "_h0-3";
export var flatBottomCorners = "_h0-5";
export var productImage = "_h0-0";
export var quantityContainer = "_h0-2";
export var tooltip = "_h0-1";
export var wrapAndEllipsesOverflow = "_h0-4";